// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  color: var(--color-black);
  text-align: left;
}
.hero p {
  font-family: AppFontLight, sans-serif;
  color: var(--color-black);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
}

.search-bar {
  background: #353535;
  border-radius: 10px;
  --inner-padding-end: 0px;
}

ion-input {
  color: #fff;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
  margin-left: 8px;
}

.start-icon {
  margin-inline-end: 12px;
}

.search-container {
  padding: 0px 20px;
}
@media (min-width: 991px) {
  .search-container {
    padding: 0px 30px;
  }
}

.search-container ion-col {
  padding: 0 !important;
  border-radius: var(--ion-border-radius);
}

.no-place {
  padding: 16px 9px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--ion-border-radius);
  font-size: 12px;
  line-height: 131.5%;
  color: #fff;
}

.suggested-place {
  border-top: 0.5px solid #fff;
  border-bottom: 0.5px solid #fff;
  place-items: center;
  padding: 8px 10px;
  margin-top: 15px;
  text-align: left;
  padding: 10px 20px;
}
@media (min-width: 991px) {
  .suggested-place {
    padding: 10px 30px;
  }
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: var(--ion-color-primary) !important;
  width: 15px;
}
.suggested-place .wrapper-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.suggested-place .actual-position {
  margin-top: 5px;
  line-height: 16px;
}

#buttonContainer {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.vertical-space-around {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.geo-btn {
  background: #62ABA4;
  font-family: AppFont-bold, sans-serif;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  text-align: center;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.geo-btn ion-icon {
  width: 22px;
  height: 25px;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .geo-btn {
    width: 600px;
    margin: auto;
  }
}

.heading-text {
  font-size: 19px;
  color: var(--ion-text-color);
  font-weight: 500;
  line-height: 145%;
  margin: 20px 0 10px;
}
.heading-text.desktop {
  display: block;
}
@media (max-width: 992px) {
  .heading-text.desktop {
    display: none;
  }
}
.heading-text.mobile {
  display: none;
}
@media (max-width: 992px) {
  .heading-text.mobile {
    display: block;
  }
}

.sub-heading {
  font-size: 18px;
  line-height: 134%;
  margin: 0;
}

.footer-btn {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: white;
  display: flex;
  width: 100%;
}

.footer-btn {
  padding: 0 28px 26px !important;
  box-shadow: none;
}
.footer-btn .button {
  flex: 1;
  text-align: center;
}
.footer-btn .button:first-child {
  margin-right: 3px;
}
.footer-btn .button:last-child {
  margin-left: 3px;
}
.footer-btn .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: var(--ion-text-color);
}
.footer-btn .button.active:hover {
  transition: 0.3s linear;
}

.desktop {
  display: none;
  margin: 50px 25px;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}
.desktop .hero {
  background: white;
  border: 0.5px solid #E5E5E5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 10px;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: block;
  }
}

.logo-block {
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo-block ion-img {
  width: 76px;
}
@media (max-width: 992px) {
  .logo-block {
    display: none;
  }
}

@media (min-width: 991px) {
  .desktop-hero {
    text-align: center;
  }
}

.pac-container {
  width: 100%;
  padding: 8px 20px !important;
  margin-top: 5px;
  border-radius: 16px !important;
  border: none !important;
  border-radius: 26px;
}
.pac-container .pac-item {
  border-top: none !important;
  font-family: AppFontMedium, sans-serif;
  padding: 16px 0;
  line-height: 1 !important;
  font-size: 14px !important;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  border-bottom: 0.3px solid #fff;
  text-align: left;
}
.pac-container .pac-item:last-child {
  border-bottom: none;
}
.pac-container .pac-item .pac-matched {
  font-family: AppFontBold, sans-serif;
}

.cross_icon {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 15px;
  right: 15px;
}
.cross_icon ion-icon {
  width: 24px;
  height: 24px;
}

.suche ion-button {
  --border-radius: 26px;
  fill: white;
  height: 100%;
  min-width: 100px;
}
@media (max-width: 992px) {
  .suche ion-button {
    min-width: 80px;
  }
}

.delivery-title {
  font-size: 20px;
  text-align: center;
  font-family: AppFont, sans-serif;
  text-transform: uppercase;
  margin: 50px 0px 25px;
}

.end-icon {
  margin-right: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component.scss"],"names":[],"mappings":"AAYA;EAEE,yBAAA;EACA,gBAAA;AAZF;AAiBE;EACE,qCAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAfJ;;AAoBA;EACE,mBAAA;EACA,mBAAA;EACA,wBAAA;AAjBF;;AAoBA;EACE,WAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,uBAAA;AAjBF;;AAoBA;EACE,iBAAA;AAjBF;AAnCE;EAmDF;IAGI,iBAAA;EAfF;AACF;;AAmBA;EACE,qBAAA;EACA,uCAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,yCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,4BAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAhBF;AAhEE;EAyEF;IASI,kBAAA;EAdF;AACF;AAgBE;EACE,kBAAA;EACA,yCAAA;EACA,WAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAfJ;AAkBE;EACE,eAAA;EACA,iBAAA;AAhBJ;;AAqBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAlBF;;AAuBA;EACE,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AApBJ;AAtHE;EAwHF;IAsBI,YAAA;IACA,YAAA;EApBF;AACF;;AAuBA;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,cAAA;AApBJ;AAjIE;EAoJA;IAGI,aAAA;EAlBJ;AACF;AAqBE;EACE,aAAA;AAnBJ;AAzIE;EA2JA;IAGI,cAAA;EAjBJ;AACF;;AAqBA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;EAAa,aAAA;EACb,WAAA;AAjBF;;AAoBA;EACE,+BAAA;EACA,gBAAA;AAjBF;AAuBE;EACE,OAAA;EACA,kBAAA;AArBJ;AAuBI;EACE,iBAAA;AArBN;AAwBI;EACE,gBAAA;AAtBN;AAyBI;EACE,uBAAA;EACA,iCAAA;EACA,4BAAA;AAvBN;AAyBM;EACE,uBAAA;AAvBR;;AA6BA;EACE,aAAA;EAKA,iBAAA;AA9BF;AA9LE;EAsNF;IAGI,cAAA;EAvBF;AACF;AA2BE;EACE,iBAAA;EACA,2BAAA;EACA,+CAAA;EACA,mBAAA;AAzBJ;;AA6BA;EACE,aAAA;AA1BF;AAvME;EAgOF;IAGI,cAAA;EAxBF;AACF;;AA2BA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAxBF;AA0BE;EACE,WAAA;AAxBJ;AArNE;EAuOF;IAUI,aAAA;EAxBF;AACF;;AAhOE;EA2PF;IAEI,kBAAA;EAxBF;AACF;;AAgCA;EAEE,WAAA;EACA,4BAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AA9BF;AAgCE;EACE,2BAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,+BAAA;EACA,gBAAA;AA9BJ;AAgCI;EACE,mBAAA;AA9BN;AAiCI;EACE,oCAAA;AA/BN;;AAoCA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AAjCF;AAmCE;EACE,WAAA;EACA,YAAA;AAjCJ;;AAsCE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAnCJ;AA/QE;EA8SA;IAMI,eAAA;EAjCJ;AACF;;AAqCA;EACE,eAAA;EAEA,kBAAA;EACA,gCAAA;EACA,yBAAA;EACA,qBAAA;AAnCF;;AAuCA;EACE,kBAAA;AApCF","sourcesContent":["@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n.hero {\n\n  color: var(--color-black);\n  text-align: left;\n  // @include mobile {\n  //   padding: 20px;\n  // }\n\n  p {\n    font-family: AppFontLight, sans-serif;\n    color: var(--color-black);\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 15px;\n  }\n}\n\n\n.search-bar {\n  background: #353535;\n  border-radius: 10px;\n  --inner-padding-end: 0px;\n}\n\nion-input {\n  color: #fff;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n  margin-left: 8px;\n}\n\n.start-icon {\n  margin-inline-end: 12px;\n}\n\n.search-container {\n  padding: 0px 20px;\n  @include desktop {\n    padding: 0px 30px;\n  }\n\n}\n\n.search-container ion-col {\n  padding: 0 !important;\n  border-radius: var(--ion-border-radius);\n}\n\n.no-place {\n  padding: 16px 9px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: var(--ion-border-radius);\n  font-size: 12px;\n  line-height: 131.5%;\n  color: #fff;\n}\n\n.suggested-place {\n  border-top: 0.5px solid #fff;\n  border-bottom: 0.5px solid #fff;\n  place-items: center;\n  padding: 8px 10px;\n  margin-top: 15px;\n  text-align: left;\n  padding: 10px 20px;\n  @include desktop() {\n    padding: 10px 30px;\n  }\n\n  .navigate-icon {\n    margin-right: 15px;\n    fill: var(--ion-color-primary) !important;\n    width: 15px;\n  }\n\n  .wrapper-icon {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .actual-position {\n    margin-top: 5px;\n    line-height: 16px;\n  }\n}\n\n\n#buttonContainer {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.vertical-space-around {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n\n\n\n.geo-btn {\n  background: #62ABA4;\n  font-family: AppFont-bold, sans-serif;\n  color: #ffffff;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    width: 22px;\n    height: 25px;\n    margin-right: 10px;\n  }\n\n  @include desktop {\n    width: 600px;\n    margin: auto;\n  }\n}\n\n.heading-text {\n  font-size: 19px;\n  color: var(--ion-text-color);\n  font-weight: 500;\n  line-height: 145%;\n  margin: 20px 0 10px;\n\n  &.desktop {\n    display: block;\n    @include mobile() {\n      display: none;\n    }\n  }\n\n  &.mobile {\n    display: none;\n    @include mobile() {\n      display: block;\n    }\n  }\n}\n\n.sub-heading {\n  font-size: 18px;\n  line-height: 134%;\n  margin: 0;\n}\n\n.footer-btn {\n  font-family: AppFontBold, sans-serif;\n  text-transform: uppercase;\n  color: white;display: flex;\n  width: 100%;\n}\n\n.footer-btn {\n  padding: 0 28px 26px !important;\n  box-shadow: none;\n  @include desktop {\n    // margin: 0px 50px 0 !important;\n    // width: calc(100% - 100px) !important;\n  }\n\n  .button {\n    flex: 1;\n    text-align: center;\n\n    &:first-child {\n      margin-right: 3px;\n    }\n\n    &:last-child {\n      margin-left: 3px;\n    }\n\n    &.active {\n      transition: 0.3s linear;\n      background: var(--ion-color-main);\n      color: var(--ion-text-color);\n\n      &:hover {\n        transition: 0.3s linear;\n      }\n    }\n  }\n}\n\n.desktop {\n  display: none;\n  @include desktop() {\n    display: block;\n  }\n\n  margin: 50px 25px;\n\n  .hero {\n    background: white;\n    border: 0.5px solid #E5E5E5;\n    box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n    border-radius: 10px;\n  }\n}\n\n.mobile {\n  display: none;\n  @include mobile() {\n    display: block;\n  }\n}\n\n.logo-block {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n\n  ion-img {\n    width: 76px;\n  }\n\n  @include mobile {\n    display: none;\n  }\n}\n\n.desktop-hero {\n  @include desktop() {\n    text-align: center;\n    // margin:15px 15px;\n  }\n\n}\n\n// .cross {\n//   fill: var(--ion-color-primary) !important;\n// }\n.pac-container {\n\n  width: 100%;\n  padding: 8px 20px !important;\n  margin-top: 5px;\n  border-radius: 16px !important;\n  border: none !important;\n  border-radius: 26px;\n\n  .pac-item {\n    border-top: none !important;\n    font-family: AppFontMedium, sans-serif;\n    padding: 16px 0;\n    line-height: 1 !important;\n    font-size: 14px !important;\n    display: flex;\n    cursor: pointer;\n    justify-content: space-between;\n    border-bottom: 0.3px solid #fff;\n    text-align: left;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .pac-matched {\n      font-family: AppFontBold, sans-serif;\n    }\n  }\n}\n\n.cross_icon {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  top: 15px;\n  right: 15px;\n\n  ion-icon {\n    width: 24px;\n    height: 24px;\n  }\n}\n\n.suche {\n  ion-button {\n    --border-radius: 26px;\n    fill: white;\n    height: 100%;\n    min-width: 100px;\n    @include mobile {\n      min-width: 80px\n    }\n  }\n}\n\n.delivery-title {\n  font-size: 20px;\n\n  text-align: center;\n  font-family: AppFont, sans-serif;\n  text-transform: uppercase;\n  margin: 50px 0px 25px;\n\n}\n\n.end-icon {\n  margin-right: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
